document.addEventListener("DOMContentLoaded", function () {
    function debounce(cb, delay = 1000) {
        let timeout
        return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay);
        };
    }
    let originalPrice = null;
    let subscriptionPrice = null;

    function updatePrice() {
        const priceContainer = document.querySelector(".dgf-comp-prc.active");

        if (priceContainer) {
            originalPrice = priceContainer.getAttribute('data-original-price');
            subscriptionPrice = priceContainer.getAttribute('data-subscription-price');

            const priceSpan = priceContainer.querySelector("[data-product-price-btn]");

            if (priceSpan && originalPrice && subscriptionPrice) {
                if (document.querySelector(".onetime-radio input")?.checked) {
                    priceSpan.textContent = originalPrice;
                } 
                else if (document.querySelector(".subscription-radio input")?.checked) {
                    priceSpan.textContent = subscriptionPrice;
                }
            }
        }
    }
    function addListeners(){
        document.querySelectorAll(".rc-radio input").forEach(container => {
            container.addEventListener("change", updatePrice);
            container.addEventListener("click", updatePrice);
        });
    }
    

    const priceContainer = document.querySelector(".dgf-prc");

    if (priceContainer) {
        function updateContainer (){
            setTimeout(()=>{
                updatePrice();
                addListeners();
            },0);
        }
        const updateContainerDebounce = debounce(updateContainer,50)
        const observer = new MutationObserver(updateContainerDebounce);

        observer.observe(priceContainer, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }

    const rechargeCheck = setInterval(() => {
        if (document.querySelectorAll(".rc-radio input").length > 0) {
            updatePrice();
            clearInterval(rechargeCheck);
        }
    }, 500);

    updatePrice();
});